import { render, staticRenderFns } from "./LabelsMapper.vue?vue&type=template&id=bb590aca&scoped=true"
import script from "./LabelsMapper.vue?vue&type=script&lang=js"
export * from "./LabelsMapper.vue?vue&type=script&lang=js"
import style0 from "./LabelsMapper.vue?vue&type=style&index=0&id=bb590aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb590aca",
  null
  
)

export default component.exports